<template>
  <v-dialog
    @input="dialogsChangePrivacePolice($event)"
    :value="show"
    width="800px"
  >
    <v-card>
      <v-card-title class="lighten-4 pt-2 title"> </v-card-title>
      <v-container class="pb-6 px-6 ">
        <v-row>
          <k-privace-police-contract></k-privace-police-contract>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import KPrivacePoliceContract from '@src/components/contracts/PrivacePolice.vue'

export default {
  computed: {
    ...mapState({
      show: (state) => state.dialogs.privacePolice,
    }),
  },
  methods: {
    ...mapActions({
      dialogsChangePrivacePolice: 'dialogs/changePrivacePolice',
    }),
  },
  components: {
    KPrivacePoliceContract,
  },
}
</script>
<style scoped>
.card .card__title {
  padding-bottom: 0;
  background-color: transparent;
  border-bottom: 1px solid gray;
}

.description span {
  display: block;
  font-size: 12px;
  color: #757575;
}

.description {
  font-size: 14px;
}

.red-box {
  border: 1px solid red;
}
</style>
